import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08ae685e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "question" }
const _hoisted_8 = {
  key: 2,
  class: "saveSuccess"
}
const _hoisted_9 = { class: "g-f18 g-fw7 g-mt20 g-mb10" }
const _hoisted_10 = { class: "g-f14" }

import { ref, onMounted, watch, computed } from "vue";
import { upgradeAccount } from "@/utils";
import { ElIcon } from "element-plus";
import serviceIcon from "@/assets/operate/service.png";
import {
  getSurveyTemplate,
  getSurveyAdd,
  getSurveyStatus,
  getSurveyClose,
} from "@/api/request/survey";
import {
  Service,
  DocumentChecked,
  Promotion,
  Calendar,
  Document,
  Ticket,
} from "@element-plus/icons-vue";
import store from "@/store";
import { postExamMyPapers } from "@/api/request/exam";
import { useRouter } from "vue-router";
import VisitorSurvey from "@/views/mobile/course/VisitorSurvey.vue";


interface templateType {
  type: "num" | "str";
  title: string;
  value: number;
}
/** 问题列表 */

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFeedBack',
  setup(__props) {

const router = useRouter();
const node_env = process.env.NODE_ENV;
const isBig6Router = computed(() => {
  return store.state.user.userInfo.useType === '6';
  // return route.path.indexOf('/bigSeaAgent') !== -1
})
function goCalendar() {
  router.push({
    path: "/mobile/courseCalendar",
  });
}
// 客诉通道
function openEmailDialog() {
  if (upgradeAccount()) return;
  const email = document.createElement("a");
  email.target = "_blank";
  email.href = "mailto:cnobi-qa@bytedance.com";
  email.click();
}
// 能力诊断
async function openAbilityDialog() {
  // if (upgradeAccount()) return;
 
   let {status} = await upgradeAccount();
   console.log(status,'status')
  if(status === 'confirm'){
    visitorSurveyVisible.value = true;
    return
  }  

  if(status === 'cancel' || status === 'close'){ 
    return
  }
  
    postExamMyPapers().then((res) => {
      if (!res.data) {
        router.push({
          path: "/mobile/exam",
          query: {
            type: "label",
          },
        });
      } else {
        router.push({
          path: "/mobile/examResult",
        });
      }
    }); 

}

const QrCodePath = ref(serviceIcon);
const drawer = ref(false);
/** 是否弹起调查问卷弹窗 */
const isShow = ref(false);
/** 是否展示调查问卷系统 */
const isHidden = ref(true);
/** 正在提交 */
const loading = ref(false);
const time = ref(3);
/** 倒计时 */
let timer: null | number = null;
/** 是否成功反馈 */
const isSuccess = ref(false);

const handleClose = (done: () => void) => {
  done();
};
function handleQuestionClose(done: () => void) {
  close();
  done();
}
const questionList = ref([] as templateType[]);
const qusetionVersion = ref("");
async function openDialog() {
  // if (upgradeAccount()) return;
 
  let {status} = await upgradeAccount();
  if(status === 'confirm'){
    visitorSurveyVisible.value = true;
    return
  }  

  if(status === 'ok'){
    isShow.value = true;
    return
  }  

  if(status === 'cancel' || status === 'close'){ 
    return
  }


  
}
/** 请求调查模板 */
function getTemplate() {
  getSurveyTemplate().then((res) => {
    questionList.value = JSON.parse(res.data.surveyJson);
    qusetionVersion.value = res.data.surveyVersion;
  });
}
const isLogin = computed(() => {
  return store.getters.isLogin;
});
onMounted(() => {
  // // 判断当前用户反馈状态
  if (isLogin.value) {
    getSurveyStatus().then((res) => {
      // if (res.data === "tip") {
      //   //不点击调查问卷就弹出
      //   isShow.value = true;
      //   getTemplate();
      // }
      // if (res.data === "normal") {
      //   //点击调查问卷弹出
      //   isShow.value = false;
      //   getTemplate();
      // }
      if (res.data === "hidden") {
        isHidden.value = false;
      } else {
        isShow.value = false;
        getTemplate();
      }
    });
  }
});
function getDrawerHeight() {
  let scale = document.documentElement.clientWidth / 540;
  return 570 * scale;
}
function getDrawerHeightQ() {
  let scale = document.documentElement.clientWidth / 540;
  return 1020 * scale;
}
/** 保存调查问卷 */
function save() {
  isSuccess.value = true;
  loading.value = true;
  getSurveyAdd({
    surveyJson: JSON.stringify(questionList.value),
    surveyVersion: qusetionVersion.value,
  })
    .then(() => {
      isSuccess.value = true;
      timer = setInterval(() => {
        time.value--;
        if (time.value <= 0) {
          clearInterval(timer as number);
          close();
        }
      }, 1000);
    })
    .finally(() => {
      loading.value = false;
    });
}
/** 关闭调查问卷 */
function close() {
  getSurveyClose();
  isShow.value = false;
  if (isSuccess.value) {
    isHidden.value = false;
  }
}
function showCustomerServic() {
  drawer.value = true;
}
function showCustomerLearnCode() {
  store.commit("SET_LEARNCODEDIALOG", true); 
}




const visitorSurveyVisible = ref(false);
 

// 显示游客调查问卷
const showVisitorSurvey = async (s:string) => { 
     visitorSurveyVisible.value = true; 
}





return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(store).state.user.learnCodeFixedDialog)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "imgIcon",
            onClick: showCustomerLearnCode
          }, [
            _createVNode(_unref(ElIcon), { size: "23" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Ticket))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "imgIcon",
        onClick: showCustomerServic
      }, [
        _createVNode(_unref(ElIcon), { size: "23" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Service))
          ]),
          _: 1
        })
      ]),
      (isHidden.value && _unref(isLogin))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "imgIcon",
            onClick: openDialog
          }, [
            _createVNode(_unref(ElIcon), { size: "23" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DocumentChecked))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(isLogin) && _unref(node_env) === 'development' && !_unref(isBig6Router) && _unref(store).state.user.userInfo.type !=='0')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "imgIcon",
            onClick: openAbilityDialog
          }, [
            _createVNode(_unref(ElIcon), { size: "23" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Document))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
      "before-close": handleClose,
      size: getDrawerHeight(),
      direction: 'btt',
      "with-header": false,
      lockScroll: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("官方客服")), 1),
          _createElementVNode("img", {
            src: QrCodePath.value,
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("飞书群二维码，立刻加入该群")), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "size"]),
    _createVNode(_component_el_drawer, {
      modelValue: isShow.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShow).value = $event)),
      "before-close": handleQuestionClose,
      direction: 'btt',
      size: getDrawerHeightQ(),
      lockScroll: false
    }, {
      header: _withCtx(({ titleId, titleClass }) => [
        _createElementVNode("h6", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(_ctx.$t("出海学堂满意度调查")), 11, _hoisted_5)
      ]),
      default: _withCtx(() => [
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.title
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                  (item.type === 'num')
                    ? (_openBlock(), _createBlock(_component_el_rate, {
                        key: 0,
                        modelValue: item.value,
                        "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                        "allow-half": "",
                        size: "large",
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        modelValue: item.value,
                        "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                        class: "feedback-input",
                        rows: 4,
                        type: "textarea",
                        placeholder: _ctx.$t('请简述您的问题')
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "commit",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (save()))
            }, _toDisplayString(_ctx.$t("提交")), 1))
          : _createCommentVNode("", true),
        (isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(ElIcon), {
                color: "#67c23a",
                size: "60"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SuccessFilled)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("感谢您的反馈")), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("秒后自动关闭", { text: time.value })), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "size"]),
    (visitorSurveyVisible.value)
      ? (_openBlock(), _createBlock(VisitorSurvey, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})